import React from 'react';
import { ALL_CATEGORIES_FILTER } from '@/utils/category';
import { HorizontalSelector } from '@/components/horizontal-selector';
import { StyleProp, ViewStyle } from 'react-native';

export const LIST_HEIGHT = 40;

interface Props {
  categories: string[];
  onCategoryPress: (category: string | null) => void;
  selectedCategory: string | null;
  style?: StyleProp<ViewStyle>;
}

export const CategorySelector: React.FC<Props> = ({
  categories,
  onCategoryPress,
  selectedCategory,
  style,
}) => {
  return (
    <HorizontalSelector<string>
      allFilter={ALL_CATEGORIES_FILTER}
      data={categories}
      keyExtractor={(category) => category}
      onItemPress={onCategoryPress}
      selectedItem={selectedCategory}
      style={style}
      trackingKey="category_selector"
    />
  );
};
